
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Text } from 'office-ui-fabric-react';

import { clearPageBackground } from '../../utils';

const classNames = mergeStyleSets({
    root: {
        width: '1024px',
        height: '100%',
    },

    container: {
        width: '1024px',
        height: '100%',
        padding: '0.2em'
    },

    continueBtn: {
        margin: '1em 0em',
        whiteSpace: 'nowrap'
    }
});

const UsekInputPageView = ({
    canContinue,
    map,
    onContinueClick,
    selectInputType,
    selectFileForImport,
    usekDetail
}) => {

    React.useEffect(() => {
        clearPageBackground();
    }, []);

    const handleContinueClick = () => {
        if (onContinueClick) {
            onContinueClick();
        }
    }

    const continueIco = { iconName: 'TriangleRight12' };

    return (
        <Stack.Item className={classNames.root}>
            <Stack grow className={classNames.container}>
                <Stack.Item grow>
                    {selectInputType}
                </Stack.Item>
                <Stack.Item grow>
                    {selectFileForImport}
                </Stack.Item>
                <Stack.Item>
                    {map}
                </Stack.Item>
                <Stack.Item>
                    {usekDetail}
                </Stack.Item>
                <Stack.Item>
                    <Stack horizontal verticalAlign="center">
                        <Stack.Item grow>
                            {canContinue && <Text>Po kliknutí na tlačítko "Pokračovat na zadání atributů úseků" bude aktuální obsah mapového okna použit při následném exportu do PDF.</Text>}
                        </Stack.Item>
                        <Stack.Item>
                            <PrimaryButton disabled={!canContinue} iconProps={continueIco} className={classNames.continueBtn} onClick={handleContinueClick}>Pokračovat na zadání atributů úseků</PrimaryButton>
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
            </Stack>
        </Stack.Item>
    )
}

export default UsekInputPageView;
